export const GOOGLE_CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid'] as const;

export const UTM_QUERY_PARAMS = [
  'utm_campaign',
  'utm_term',
  'utm_source',
  'utm_medium',
  'utm_content',
  'ltk_gcm',
  'ltk_gag',
  'ltk_gac',
  'ltk_gne',
  ...GOOGLE_CLICK_ID_PARAMS,
  'fbclid',
] as const;
